import type { Messages } from "./en";
export const vi: Messages = {
  "meta.title": "ArtLove365 - Tranh sơn dầu vẽ tay",
  "meta.description": "Tranh sơn dầu vẽ tay chép lại những kiệt tác nổi tiếng nhất thế giới, và tranh chân dung sơn dầu vẽ theo ảnh của bạn.",
  "nav.gallery": "Bộ sưu tập",
  "nav.artists": "Họa sĩ",
  "nav.custom": "Vẽ ảnh của tôi",
  "nav.track": "Tra cứu đơn hàng",
  "home.eyebrow": "Vẽ tay bằng sơn dầu, bởi họa sĩ thật",
  "home.title": "Kiệt tác cho bức tường nhà bạn. Kỷ niệm của bạn, vẽ như một kiệt tác.",
  "home.subtitle": "Chọn từ những bức tranh được yêu thích nhất lịch sử, hoặc tải lên ảnh của chính bạn. Họa sĩ của chúng tôi vẽ tay trên toan và giao tận nhà.",
  "home.ctaGallery": "Xem bộ sưu tập",
  "home.ctaCustom": "Tải ảnh lên",
  "home.stepsTitle": "Cách đặt tranh",
  "home.step1Title": "Chọn tranh hoặc tải ảnh",
  "home.step1Body": "Chọn một kiệt tác, hoặc tải lên ảnh gia đình, thú cưng hay nơi bạn yêu thích.",
  "home.step2Title": "Chúng tôi vẽ",
  "home.step2Body": "Họa sĩ chuyên nghiệp vẽ trên toan thật. Với tranh theo ảnh, bạn duyệt bản phác thảo trước khi vẽ.",
  "home.step3Title": "Giao đến bạn",
  "home.step3Body": "Sau khi khô, tranh được đóng gói cẩn thận và gửi đi khắp thế giới, có mã theo dõi.",
  "home.featured": "Kiệt tác nổi bật",
  "gallery.title": "Bộ sưu tập kiệt tác",
  "gallery.subtitle": "Mỗi bức tranh đều được vẽ tay bằng sơn dầu trên toan - không phải tranh in.",
  "gallery.filterAll": "Tất cả họa sĩ",
  "gallery.empty": "Không tìm thấy tranh nào.",
  "artists.title": "Các bậc thầy",
  "artists.works": "Xem tác phẩm",
  "artwork.by": "của",
  "artwork.order": "Đặt vẽ bức tranh này",
  "artwork.notFound": "Không tìm thấy bức tranh này.",
  "order.size": "Kích thước toan",
  "order.frame": "Hoàn thiện",
  "frame.rolled": "Toan cuộn (đựng trong ống)",
  "frame.stretched": "Căng khung, treo được ngay",
  "frame.framed": "Căng khung + khung gỗ",
  "order.subjects": "Số người hoặc thú cưng trong ảnh",
  "order.price.base": "Tranh",
  "order.price.frame": "Hoàn thiện",
  "order.price.custom": "Chân dung theo ảnh",
  "order.price.shipping": "Phí giao hàng",
  "order.price.free": "Miễn phí",
  "order.price.total": "Tổng cộng",
  "order.contact": "Thông tin giao hàng",
  "order.name": "Họ và tên",
  "order.email": "Email",
  "order.phone": "Số điện thoại",
  "order.address": "Địa chỉ",
  "order.city": "Thành phố",
  "order.postalCode": "Mã bưu chính",
  "order.country": "Quốc gia",
  "order.notes": "Ghi chú cho họa sĩ (không bắt buộc)",
  "order.submit": "Tiếp tục thanh toán",
  "order.submitting": "Đang đặt hàng…",
  "order.error": "Đã có lỗi xảy ra. Vui lòng kiểm tra lại thông tin và thử lại.",
  "order.leadTime": "Thời gian vẽ 2-3 tuần, cộng 1 tuần để tranh khô trước khi gửi.",
  "custom.title": "Biến ảnh của bạn thành tranh sơn dầu",
  "custom.subtitle": "Tải lên một bức ảnh rõ nét, đủ sáng. Họa sĩ sẽ vẽ tay - và bạn duyệt bản phác thảo trước khi chúng tôi bắt đầu.",
  "custom.upload": "Chọn ảnh",
  "custom.uploadHint": "JPG, PNG hoặc WebP, tối đa 20 MB. Ảnh càng nét, tranh càng đẹp.",
  "custom.uploading": "Đang tải lên…",
  "custom.uploaded": "Đã tải ảnh lên",
  "custom.replace": "Dùng ảnh khác",
  "custom.style": "Phong cách vẽ",
  "custom.style.classic": "Hiện thực cổ điển",
  "custom.style.impressionist": "Ấn tượng (như Monet)",
  "custom.style.vangogh": "Nét cọ mạnh (như Van Gogh)",
  "custom.style.modern": "Hiện đại, gam màu dịu",
  "custom.needPhoto": "Vui lòng tải ảnh lên trước.",
  "track.title": "Tra cứu đơn hàng",
  "track.code": "Mã đơn hàng",
  "track.submit": "Tìm đơn hàng",
  "track.notFound": "Không tìm thấy đơn hàng nào khớp với mã và email này.",
  "track.placed": "Ngày đặt",
  "success.title": "Cảm ơn bạn! Đơn hàng đã được ghi nhận.",
  "success.body": "Chúng tôi đã gửi email xác nhận. Hãy giữ mã đơn hàng để theo dõi tiến độ.",
  "status.awaiting_payment": "Chờ thanh toán",
  "status.paid": "Đã thanh toán",
  "status.sketching": "Đang phác thảo",
  "status.painting": "Đang vẽ",
  "status.drying": "Đang phơi khô",
  "status.shipped": "Đã gửi hàng",
  "status.delivered": "Đã giao",
  "status.cancelled": "Đã huỷ",
  "common.loading": "Đang tải…",
  "common.back": "Quay lại",
  "footer.tagline": "Tranh sơn dầu vẽ tay, giao hàng toàn cầu.",
  "footer.follow": "Theo dõi chúng tôi",
  "footer.docs": "Trợ giúp và tài liệu",
  "gallery.search": "Tìm tranh hoặc họa sĩ…",
  "sketch.title": "Bản phác thảo đã sẵn sàng",
  "sketch.body": "Vui lòng kiểm tra bố cục. Chúng tôi chỉ bắt đầu vẽ sau khi bạn duyệt.",
  "sketch.approve": "Duyệt phác thảo",
  "sketch.change": "Yêu cầu chỉnh sửa",
  "sketch.feedback": "Bạn muốn chúng tôi sửa gì?",
  "sketch.send": "Gửi góp ý",
  "sketch.approved": "Đã duyệt phác thảo - họa sĩ đang vẽ.",
  "sketch.changesSent": "Cảm ơn bạn! Họa sĩ sẽ gửi bản phác thảo đã chỉnh sửa.",
  "checkout.title": "Thanh toán",
  "checkout.demoBanner": "Chế độ demo - thanh toán trực tuyến chưa hoạt động. Bạn sẽ không bị trừ tiền và chúng tôi không thu thập thông tin thẻ.",
  "checkout.summary": "Tóm tắt đơn hàng",
  "checkout.method": "Phương thức thanh toán",
  "checkout.method.card": "Thẻ tín dụng / ghi nợ",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Chuyển khoản ngân hàng",
  "checkout.cardNumber": "Số thẻ",
  "checkout.expiry": "Hết hạn (MM/YY)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Tên chủ thẻ",
  "checkout.paypalNote": "Bạn sẽ được chuyển sang PayPal để xác nhận thanh toán.",
  "checkout.walletNote": "Xác nhận bằng Face ID, Touch ID hoặc điện thoại.",
  "checkout.bankNote": "Chúng tôi sẽ gửi thông tin tài khoản qua email. Đơn hàng bắt đầu khi nhận được tiền (1-3 ngày làm việc).",
  "checkout.pay": "Thanh toán {amount}",
  "checkout.processing": "Đang xử lý thanh toán…",
  "checkout.secure": "Thanh toán được mã hoá và xử lý bởi đối tác thanh toán. Chúng tôi không bao giờ lưu số thẻ.",
  "checkout.demoDoneTitle": "Đã mô phỏng thanh toán",
  "checkout.demoDoneBody": "Đây là bản demo - bạn không bị trừ tiền. Đơn hàng đã được lưu và vẫn ở trạng thái “Chờ thanh toán”; chúng tôi sẽ liên hệ để hoàn tất thanh toán.",
  "checkout.failTitle": "Thanh toán bị từ chối",
  "checkout.failBody": "Ngân hàng đã từ chối giao dịch. Vui lòng kiểm tra lại thông tin hoặc thử phương thức khác.",
  "checkout.retry": "Thử lại",
  "checkout.viewOrder": "Xem đơn hàng",
  "track.payNow": "Thanh toán ngay",
  "browse.title": "Khám phá",
  "browse.movements": "Trường phái",
  "browse.museums": "Bảo tàng",
  "browse.subjects": "Chủ đề",
  "browse.genres": "Thể loại",
  "artwork.year": "Năm",
  "artwork.size": "Kích thước bản gốc",
  "artwork.museum": "Bảo tàng",
  "artwork.movement": "Trường phái",
  "artwork.genre": "Thể loại",
  "artwork.subjects": "Chủ đề",
  "artwork.moreBy": "Tranh khác của",
  "pager.prev": "Trước",
  "pager.next": "Sau",
  "count.paintings": "{n} bức tranh",
  "fav.add": "Thêm vào yêu thích",
  "fav.remove": "Bỏ khỏi yêu thích",
  "fav.title": "Tranh yêu thích",
  "fav.empty": "Bạn chưa có tranh yêu thích nào. Chạm vào trái tim trên bức tranh bạn thích, nó sẽ chờ bạn ở đây.",
  "fav.emptyCta": "Khám phá bộ sưu tập",
  "fav.syncHint": "Đăng nhập bằng Google để giữ tranh yêu thích trên mọi thiết bị.",
  "fav.saved": "Đã lưu vào yêu thích",
  "fav.nav": "Yêu thích",
  "account.signIn": "Đăng nhập",
  "account.signOut": "Đăng xuất",
  "account.signedInAs": "Đang đăng nhập:",
  "account.signInTitle": "Đăng nhập ArtLove365",
  "viewer.open": "Xem toàn màn hình",
  "viewer.close": "Đóng",
  "viewer.hint": "Cuộn hoặc chụm hai ngón để phóng to · kéo để xem · nhấp đúp để trở lại",
  "share.button": "Chia sẻ",
  "share.copied": "Đã sao chép liên kết",
  "artwork.story": "Về bức tranh này",
  "artwork.details": "Thông tin",
  "artwork.aboutArtist": "Về họa sĩ",
  "artwork.readArtist": "Khám phá cuộc đời {name}",
  "artwork.relatedArtists": "Tranh của các họa sĩ liên quan",
  "rel.influenced_by": "Truyền cảm hứng cho {artist}",
  "rel.influenced": "Chịu ảnh hưởng từ {artist}",
  "rel.student_of": "Thầy của {artist}",
  "rel.student": "Học trò của {artist}",
  "rel.movement": "Cùng trường phái {movement}",
  "story.didYouKnow": "Có thể bạn chưa biết",
  "story.sources": "Nguồn",
  "story.aiNote": "Bài viết được soạn với sự hỗ trợ của AI dựa trên các nguồn bên dưới. Nếu thấy sai sót, xin hãy báo cho chúng tôi.",
  "artist.relatedArtists": "Họa sĩ liên quan",
  "artist.worksBy": "Tranh của {name}",
  "nav.how": "Cách chúng tôi làm việc",
  "home.ctaArtists": "Gặp gỡ các họa sĩ",
  "home.discover": "Tìm hiểu về chúng tôi",
  "home.howCardTitle": "Cách chúng tôi làm việc",
  "home.howCardBody": "Họa sĩ thật, toan thật, sơn dầu và sự kiên nhẫn. Xem một kiệt tác được vẽ lại bằng tay như thế nào.",
  "home.customCardTitle": "Ảnh của bạn, vẽ bằng sơn dầu",
  "home.customCardBody": "Gia đình, đôi lứa, thú cưng, ngôi nhà tuổi thơ - xem cách một bức ảnh trở thành bức tranh.",
  "home.featuredArtists": "Gặp gỡ các bậc thầy",
  "home.browseMovements": "Khám phá theo trường phái",
  "common.readMore": "Xem thêm",
  "how.title": "Cách chúng tôi làm việc",
  "how.intro": "Mỗi bức tranh của ArtLove365 đều được họa sĩ chuyên nghiệp vẽ tay bằng sơn dầu trên toan thật. Không in ấn, không đi tắt. Đây là hành trình từ một kiệt tác đến bức tường nhà bạn.",
  "how.s1t": "Bắt đầu từ một bức tranh bạn yêu",
  "how.s1b": "Dạo qua hàng nghìn kiệt tác, đọc câu chuyện của từng bức, và lưu những bức làm bạn rung động vào mục yêu thích.",
  "how.s2t": "Họa sĩ nghiên cứu bản gốc",
  "how.s2b": "Trước nét cọ đầu tiên, họa sĩ nghiên cứu bố cục, màu sắc và cách bậc thầy đặt sơn - thứ tự các lớp sơn quan trọng không kém màu sắc.",
  "how.s3t": "Vẽ tay, từng lớp một",
  "how.s3b": "Sơn dầu được đắp dần: lớp lót, các mảng lớn, rồi chi tiết và lớp láng màu. Một bức cỡ vừa mất hai đến ba tuần làm việc.",
  "how.s4t": "Kiểm tra, rồi phơi khô",
  "how.s4b": "Một họa sĩ lâu năm so bức tranh với bản gốc. Sau đó sơn dầu cần khoảng một tuần để khô trước khi có thể đi xa an toàn.",
  "how.s5t": "Đóng gói cẩn thận, gửi khắp thế giới",
  "how.s5b": "Tranh được cuộn trong ống cứng hoặc căng khung trong thùng gia cố, có mã theo dõi đến tận cửa nhà bạn.",
  "how.materialsTitle": "Chất liệu",
  "how.materialsBody": "Sơn dầu loại dành cho họa sĩ, toan cotton hoặc lanh đã xử lý nền, và lớp vecni bảo vệ bề mặt hàng chục năm.",
  "how.customTitle": "Vẽ từ ảnh của chính bạn",
  "how.customBody": "Với chân dung và cảnh riêng tư, chúng tôi thêm một bước: bạn duyệt bản phác thảo bố cục trước khi chúng tôi bắt đầu vẽ.",
  "custom.pageTitle": "Tranh sơn dầu vẽ theo ảnh của bạn",
  "custom.pageIntro": "Một tấm ảnh giữ lại khoảnh khắc. Một bức tranh khiến nó ở lại mãi. Họa sĩ của chúng tôi biến ảnh của bạn thành chân dung và khung cảnh vẽ tay bằng sơn dầu - theo phong cách bạn chọn.",
  "custom.howTitle": "Quy trình",
  "custom.step1t": "Bạn chia sẻ ảnh",
  "custom.step1b": "Chỉ cần một tấm ảnh rõ nét; chúng tôi cũng có thể ghép nhiều ảnh thành một khung cảnh.",
  "custom.step2t": "Bạn duyệt phác thảo",
  "custom.step2b": "Họa sĩ chuẩn bị bố cục. Chưa vẽ gì cho đến khi bạn hài lòng.",
  "custom.step3t": "Chúng tôi vẽ tay",
  "custom.step3b": "Sơn dầu trên toan, từng lớp một, theo phong cách bạn đã chọn.",
  "custom.step4t": "Tranh về nhà",
  "custom.step4b": "Sau khi khô và kiểm tra lần cuối, tranh được đóng gói và gửi đi kèm mã theo dõi.",
  "custom.stylesTitle": "Chọn phong cách",
  "custom.styleDesc.classic": "Giống thật, ánh sáng dịu và chi tiết tinh tế, theo truyền thống các bậc thầy cổ điển.",
  "custom.styleDesc.impressionist": "Ánh sáng và không khí trong những nét cọ thoáng, rực rỡ - như một buổi chiều hè của Monet.",
  "custom.styleDesc.vangogh": "Nét cọ dày, cuộn xoáy và màu sắc mạnh mẽ, lấy cảm hứng từ Van Gogh.",
  "custom.styleDesc.modern": "Hình khối gọn gàng, gam màu dịu và hiện đại, hợp với nội thất ngày nay.",
  "custom.occasionsTitle": "Được yêu thích cho",
  "custom.occ.family": "Chân dung gia đình",
  "custom.occ.couples": "Đôi lứa và đám cưới",
  "custom.occ.pets": "Thú cưng",
  "custom.occ.children": "Trẻ em",
  "custom.occ.memorial": "Tưởng nhớ người thân",
  "custom.occ.home": "Ngôi nhà và nơi chốn",
  "custom.tipsTitle": "Chọn ảnh thế nào cho đẹp",
  "custom.tip1": "Ảnh nét, nhất là phần mắt.",
  "custom.tip2": "Ánh sáng ban ngày dịu; tránh đèn flash gắt và filter nặng.",
  "custom.tip3": "Khuôn mặt đủ lớn để thấy rõ biểu cảm.",
  "custom.tip4": "Có nhiều ảnh? Chúng tôi có thể ghép người hoặc thú cưng vào một bức tranh.",
  "custom.explore": "Khám phá các phong cách trong bộ sưu tập",
  "showcase.title": "Những bức tranh chúng tôi đã vẽ",
  "showcase.subtitle": "Tranh thật vẽ cho khách hàng, được đăng khi khách đồng ý.",
  "showcase.all": "Tất cả",
  "custom.occ.nail": "Tranh trang trí tiệm nail",
  "custom.occ.other": "Khác",
  "home.newTitle": "Mới có câu chuyện",
  "home.newWhy": "Những bức tranh vừa được kể trọn câu chuyện - ngày nào cũng có điều mới.",
  "home.gemsTitle": "Viên ngọc ít người biết",
  "home.gemsWhy": "Ít nổi tiếng hơn, nhưng không kém phần xúc động. Những bức tranh mà hầu hết mọi người lướt qua - và không nên lướt qua.",
  "taxon.faqTitle": "Bạn tò mò về {name}?",
  "notFound.title": "Không tìm thấy trang",
};
